import PriceComparisonAlertExecutionNotification from '@app/model/alert/PriceComparisonAlertExecutionNotification';

class AlertUtilities {

	public static calculateDifference = (n: PriceComparisonAlertExecutionNotification) => {
		const calc = (n.price.amount - n.competitorsPrice.amount) / n.competitorsPrice.amount;
		return calc * 100;
	};
}

export default AlertUtilities;